import PropTypes from 'prop-types';
import Entity from '@/common-utils/components/renders/entity/Entity';
import PAYLUDD_PERSONALIZATION_INITIALIZATION_STATUS from '../../../payludd/subscriptions/enums/PayluddPackageStatus';

/**
 * @param root
 * @param root.cellValue
 * @returns {JSX} RenderIniStatus
 */
function RenderInitStatus({ cellValue }) {
    // Constants
    const initStatus = PAYLUDD_PERSONALIZATION_INITIALIZATION_STATUS[cellValue];

    return (
        <div>
            {cellValue && initStatus ?
                <Entity entity={initStatus.entity} namespace={initStatus.namespace} />
                : false
            }
        </div>
    );
}

RenderInitStatus.propTypes = {
    cellValue: PropTypes.string
};
export default RenderInitStatus;
